export default "__VITE_ASSET__face3f20__"